__webpack_require__.p = "https://beta.na.excavator.whs.amazon.dev/";